import { render, staticRenderFns } from "./ProjectSlide.vue?vue&type=template&id=4ad446a5&scoped=true"
import script from "./ProjectSlide.vue?vue&type=script&lang=js"
export * from "./ProjectSlide.vue?vue&type=script&lang=js"
import style0 from "./ProjectSlide.vue?vue&type=style&index=0&id=4ad446a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad446a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VProgressCircular,VRow})
